import React, { FC } from "react";
import "./style.scss";
import { LazyReactDatePicker } from "utils/lazy-libs";
import Calendar from "../../../../assets/Calendar.svg";
import { useTranslation } from "react-i18next";

type PropsType = {
  deadline: string | "Start" | "End" | "Year";
  selected: any;
  onChange: any;
  report?: boolean;
  withPortal?: boolean;
  repoFilter?: boolean;
  repoLabel?: string;
};

const DatePicker: FC<PropsType> = ({
  deadline,
  selected,
  onChange,
  report = false,
  withPortal = false,
  repoFilter = false,
  repoLabel,
}) => {
  const { t } = useTranslation("app");

  if (report == true) {
    return (
      <div className="report-date-picker-container">
        <span>
          {deadline} {deadline !== "Year" && t("date")}
        </span>

        <LazyReactDatePicker
          calendarClassName={deadline === "Year" ? "calendar-year" : undefined}
          selected={selected}
          className="date-picker"
          showYearPicker={deadline === "Year"}
          dateFormat={deadline === "Year" ? "yyyy" : "yyyy.MM.dd"}
          //@ts-ignore
          onChange={onChange}
          showIcon
          //@ts-ignore
          icon={<img src={Calendar} alt="icon" />}
          withPortal={withPortal}
        />
      </div>
    );
  } else {
    return (
      <div
        className={
          repoFilter
            ? "date-picker-container date-picker-container-repo"
            : "date-picker-container"
        }
      >
        {repoFilter && repoLabel ? (
          <span style={{ textTransform: "capitalize" }}>{t(repoLabel)}</span>
        ) : (
          <span>
            {deadline} {t("date")}
          </span>
        )}
        {repoFilter && repoLabel ? (
          <LazyReactDatePicker
            selected={selected}
            className="date-picker"
            //@ts-ignore
            onChange={onChange}
            showIcon
            //@ts-ignore
            icon={<img src={Calendar} alt="icon" />}

            placeholderText="yyyy.mm.dd"
            calendarClassName={
              deadline === "Year" ? "calendar-year" : undefined
            }
            showYearPicker={deadline === "Year"}
            dateFormat={deadline === "Year" ? "yyyy" : "yyyy.MM.dd"}
          />
        ) : (
          <LazyReactDatePicker
            selected={selected}
            className="date-picker"
            //@ts-ignore
            onChange={onChange}
            showIcon
            //@ts-ignore
            icon={<img src={Calendar} alt="icon" />}
          />
        )}
      </div>
    );
  }
  return <></>;
};

export default DatePicker;
